import Rect from "./Rect";
import Size from "./Size";

type WidgetBounds = Pick<Rect, "top" | "left" | "width" | "height">;

export default (widgetBounds: WidgetBounds, containerSize: Size) => new Rect(
    // This appears to be the same calculations done in the editor on set/get.
    (widgetBounds.left * containerSize.width / 100),
    (widgetBounds.top * containerSize.height / 100),
    (widgetBounds.width * containerSize.width / 100),
    (widgetBounds.height * containerSize.height / 100)
);



// WEBPACK FOOTER //
// ./src/shared/xp/geom/pixelRect.ts